import React from "react";
import cx from 'classnames';
import {Space} from "antd";
import {RightOutlined} from "@ant-design/icons";
import MobileComponentWrapper from "@/components/MobileComponentWrapper";
import PcComponentWrapper from "@/components/PcComponentWrapper";
import styles from './styles.module.less'

type TData = {
  data:{label: string;href: string}[];
  path_name:string;
}

const Data:React.FC<TData> = ({path_name='',data=[]}) => {
  return (
    <div className={styles.exam_data_wrapper}>
      {data.length > 0 && (
        <>
          <h3 className={styles.title}>相关学习资料</h3>
          <div className={styles.body}>
            <a href={data[0].href} target="_blank" rel="noreferrer">
              <div className={styles.exam_path}>
                <p className={styles.exam_path_title}>学习路径</p>
                <p className={styles.exam_path_subtitle}>{`${path_name} study path`}</p>
                <Space className={styles.icon_wrapper}>
                  立即查看
                  <RightOutlined className={styles.icon}/>
                </Space>
              </div>
            </a>
            <MobileComponentWrapper>
              <div className={styles.exam_data_item_body}>
                {data.slice(1).map((item,index) => {
                  return (
                    <a rel="noreferrer" href={item.href} target="_blank" key={item.label} className={cx(styles.exam_data_item_wrapper)}>
                      {item.label}
                    </a>
                  )
                })}
              </div>
            </MobileComponentWrapper>
            <PcComponentWrapper className={styles.expand}>
              <div className={styles.exam_data_item_body}>
                {data.slice(1).map((item,index) => {
                  const colNum = 2;
                  const rowNum = Math.round(data.slice(1).length / colNum); // 一列2个
                  const gap = (rowNum - 1)*10;
                  const idx = index + 1 ;
                  const percentage = Math.floor(100 / rowNum);
                  return (
                    <a rel="noreferrer" href={item.href} target="_blank" key={item.label} className={cx(styles.exam_data_item_wrapper,idx <= rowNum && styles.row,idx%rowNum === 0 ? styles.break : styles.have_gap)} style={{width: `calc(${percentage}% - ${gap}px)`}}>
                      {item.label}
                    </a>
                  )
                })}
              </div>
            </PcComponentWrapper>
          </div>
        </>
      )}
    </div>
  )
}
export default Data;
